import { injectStrict } from '@/utils/injectStrict';
import { veeFormInjectionKey } from './useVeeForm';

export function useFormContext() {
  const formContext = injectStrict(veeFormInjectionKey);

  return { formContext };
}
